module.exports = __webpack_public_path__ + "img/视频封面18.991acd13.png";